import styled, { css } from "styled-components";

import Paper from "components/Layout/Paper";

import { COLORS } from "constants/colorScheme";

const CARD_HEIGHT = 120;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  background-color: ${COLORS.WHITE};
  border-radius: 8px;

  ${({ isDragging }: { isDragging?: boolean }) =>
    isDragging &&
    css`
      border: 2px solid ${COLORS.CYAN};
    `}
`;

export const ImageContainer = styled.div`
  min-width: 120px;
  min-height: ${CARD_HEIGHT}px;

  background-image: url(${({ image }: { image: string }) => image});
  background-size: cover;

  border-radius: 8px;
`;

export const DetailsContainer = styled(Paper)`
  display: flex;
  justify-content: center;

  height: ${CARD_HEIGHT}px;
  width: 100%;

  padding: 24px 24px 16px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleWrapper = styled.div`
  margin-bottom: 4px;
`;

export const BottomControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ControlWrapper = styled.div`
  margin-right: 40px;
`;

export const MenuContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  min-width: ${({ isDraggable }: { isDraggable?: boolean }) =>
    isDraggable ? "236px" : "190px"};
`;

export const MenuContentWrapper = styled.div`
  margin-right: 24px;
`;

export const Menu = styled.div`
  display: flex;

  & path,
  & use {
    fill: ${COLORS.BLACK_50};
  }
`;
